module.exports = __webpack_public_path__ + "assets/img/EKS-smiley-happy.272ae8ff.svg";